import React, { useState } from "react";
import CouponsTable from "./CouponsTable";
import CouponsSummary from "./CouponsSummary";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import UsedCouponsTable from "./UsedCouponsTable";
import Button from "../../ui/Button";
import CreateCouponModal from "./modals/CreateCouponModal";
import EditCouponModal from "./modals/EditCoupon";
import ConfirmDeleteCouponModal from "./modals/DeleteCoupon";
import { fetchAllCoupons } from "../../../redux/features/CouponSlice";

const Coupons = () => {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [activeTab, setActiveTab] = useState(1);
  const { coupons, usedCoupons } = useAppSelector((state) => state.coupons);
  const [selectedCoupon, setSelectedCoupon] = useState<any>();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const dispatch = useAppDispatch();

  const tabList = [
    {
      id: 1,
      name: "Active Coupons",
      count: coupons?.data?.meta?.totalItems ?? 0,
    },
    { id: 2, name: "Used", count: usedCoupons?.data?.meta?.totalItems ?? 0 },
  ];

  return (
    <div className="p-6 flex flex-col gap-10">
      <p className="font-bold text-2xl">Coupons Management</p>
      <CouponsSummary />

      <WhiteTitledCard>
        <div className="px-6">
          <div className="flex-col-reverse sm:flex-row flex sm:items-center sm:justify-between mb-4 gap-2">
            <div className="flex space-x-4 items-center">
              {tabList?.map((tab) => (
                <div
                  key={tab.id}
                  className={`space-x-2 cursor-pointer text-sm font-semibold p-2 ${
                    activeTab === tab.id
                      ? "text-black border-b-2 border-primary"
                      : ""
                  }`}
                  onClick={() => {
                    setActiveTab(tab.id);
                    setPage(0);
                    setLimit(10);
                  }}
                >
                  <span>{tab.name}</span>
                  {
                    <span
                      className={"bg-lightPurple px-2  text-accent rounded-md"}
                    >
                      {tab?.count}
                    </span>
                  }
                </div>
              ))}
            </div>

            <Button
              customStyle={{ width: "auto", height: "40px" }}
              label="Create Coupon"
              onClick={() => setCreateModalOpen(true)}
              classNames="hidden sm:flex"
            />
          </div>
        </div>
        {activeTab === 1 && (
          <CouponsTable
            page={page}
            limit={limit}
            setLimit={setLimit}
            setPage={setPage}
            setDeleteModalOpen={setDeleteModalOpen}
            setEditModalOpen={setEditModalOpen}
            setSelectedCoupon={setSelectedCoupon}
            selectedCoupon={selectedCoupon}
          />
        )}
        {activeTab === 2 && (
          <UsedCouponsTable
            page={page}
            limit={limit}
            setLimit={setLimit}
            setPage={setPage}
          />
        )}
      </WhiteTitledCard>

      <CreateCouponModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSave={() => dispatch(fetchAllCoupons({ page: page + 1, limit }))}
      />
      <EditCouponModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        selectedCoupon={selectedCoupon}
        onSave={() => dispatch(fetchAllCoupons({ page: page + 1, limit }))}
      />
      <ConfirmDeleteCouponModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        couponId={selectedCoupon?.id}
        onDeleted={() => dispatch(fetchAllCoupons({ page: page + 1, limit }))}
      />
    </div>
  );
};

export default Coupons;
